import React from "react";
import PropTypes from "prop-types";
import { FormattedMessage, FormattedHTMLMessage } from "react-intl";
import { StyledHeader } from "./styles";
import messages from "./messages";

const HeaderDescription = props => {
  const { currentStep } = props;

  return (
    <React.Fragment>
          <StyledHeader>
            {currentStep === "product" && (
              <FormattedMessage {...messages.product} />
            )}
            {currentStep === "forecast" && (
              <FormattedHTMLMessage {...messages.forecast} />
            )}
          </StyledHeader>
    </React.Fragment>
  );
};

HeaderDescription.propTypes = {
  currentStep: PropTypes.string
};

export default HeaderDescription;
